<template>
    <div class="map-select">
        <div class="heading mt-0 mb-4 d-flex flex-column flex-lg-row justify-content-between align-items-center"
             v-if="!readOnly">
            <b-input-group append="Oregon, USA" class="map-select__input-wrapper">
                <b-form-input placeholder="Search for an address..." v-model="searchText"
                              class="map-select__input"/>
            </b-input-group>
            <b-form-invalid-feedback>Location was not found</b-form-invalid-feedback>
            <b-button variant="primary" @click="search" class="map-select__button ml-lg-3">Search</b-button>
        </div>

        <div class="map-div">

            <gmap-map
                ref="mapRef"
                :center="{lat:45.5, lng:-122.67}"
                :zoom="10"
                style="width: 100%; height: 0; padding-top:50%;"
                map-type-id="terrain"/>

        </div>
        <b-button v-if="!readOnly" class="float-right mt-3" variant="danger" @click="reset">Clear</b-button>
    </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'

export default {
    name: 'MapSelector',
    props: {
        value: Array,
        readOnly: Boolean,
    },
    data () {
        return {
            markers: [],
            polygon: null,
            boundsFit: false,
            searchText: '',
            searchValid: null,
        }
    },
    computed: {
        google: gmapApi,
        paths () {
            return this.markers.map((m) => {
                return { lat: m.position.lat(), lng: m.position.lng() }
            })
        }
    },
    methods: {
        search () {
            if (this.searchText) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    let geocoder = new this.google.maps.Geocoder()

                    geocoder.geocode({ 'address': this.searchText + ' oregon usa' }, (results, status) => {
                        if (status === 'OK') {
                            map.setCenter(results[0].geometry.location)
                            map.setZoom(16)
                            this.searchValid = true
                        } else {
                            this.searchValid = false
                        }
                    })
                })
            }
        },
        reset () {
            this.markers.forEach((m, i) => {
                m.setMap(null)
            })
            this.markers = []

            this.polygon.setMap(null)
            this.polygon = null
            this.$emit('input', this.paths)
        },
    },
    mounted () {
        this.$refs.mapRef.$mapPromise.then((map) => {
            let bounds = new this.google.maps.LatLngBounds()
            let makePolygon = () => {
                if (this.polygon) {
                    this.polygon.setMap(null)
                }
                this.polygon = new this.google.maps.Polygon({
                    map,
                    paths: this.paths,
                    strokeColor: '#FFFF00',
                    strokeWeight: 2,
                })

                this.$emit('input', this.paths)
            }
            let makeMarker = (point) => {
                let marker = new this.google.maps.Marker({
                    position: point,
                    map: map,
                    draggable: !this.readOnly,
                })
                this.markers.push(marker)
                marker.addListener('dragend', (e) => {
                    makePolygon()
                })
            }

            this.value?.forEach((point) => {
                bounds.extend(point)
                makeMarker(point)
            })
            makePolygon()

            if (!this.readOnly) {
                map.addListener('click', (e) => {
                    makeMarker(e.latLng)
                    makePolygon()
                })
            }

            // hack for setting bounds only once map has rendered
            map.addListener('tilesloaded', (e) => {
                if (!this.boundsFit) {
                    if (this.markers.length > 1) {
                        map.fitBounds(bounds)
                    }
                    this.boundsFit = true
                }
            })

        })
    }
}
</script>

<style lang="scss">
.map-div {
    background: #fff;
    padding: 20px;
    border: solid 3px #ddd;
}

@media (max-width: 990px) {
    .map-select .heading {
        position: relative;
        padding-right: 136px;
    }
    .map-select__button {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
    }

}

@media (max-width: 500px) {
    .map-select .heading {
        padding-right: 100px;
    }
    .map-select__button {
        min-height: 38px !important;
        padding: 0 15px !important;
    }
}


</style>